import { createContext, use } from 'react';
import type { PuckData } from '~/editor/config';
import { type SerializedPuckData } from '~/editor/SerializedPuckData';

const context = createContext<PuckData | null>(null);

export function MicrositePuckProvider({ children, data }: { children: React.ReactNode; data: PuckData }) {
	return <context.Provider value={data}>{children}</context.Provider>;
}

export default function useMicrositePuck(): SerializedPuckData {
	const ctx = use(context);

	if (!ctx) {
		throw new Error('useMicrositePuck must be used within a MicrositePuckProvider');
	}

	return ctx as SerializedPuckData;
}
